"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.invalidPasswordMessage = void 0;
exports.isValidPassword = isValidPassword;
/** Validates a password according to DAYMADE's password rules. Returns true if the password is acceptable */
function isValidPassword(password) {
    if (!password) {
        return false;
    }
    // At least one number/uppercase character. At least 8 characters.
    const expression = /((?=.*\W|_)|(?=.*\d)|(?=.*[A-Z])).{8,}/;
    return expression.test(password);
}
/** The message to be shown when a password does not meet the requirements of isValidPassword above */
exports.invalidPasswordMessage = 'Please create a password with at least 8 characters and a number/special character.';
//# sourceMappingURL=validationRules.js.map